import { JWTAuth } from "../../../../lib/js-apiclient"
import { AdvancedApiClient } from "../../../../lib/js-apiclient/src/AdvancedApiClient";

export class IntramirrorBrandMapApiClient extends AdvancedApiClient {

    static entityType = "IntramirrorBrandMap"

    constructor(token, brandId, id) {
        super();

        this.setEntityType(IntramirrorBrandMapApiClient.entityType)

        if(id !== undefined && id !== null) {
            this.setRoute("/api/v1/brand/{bid}/intramirror-map/{id}")
                .setRouteParam("bid", brandId)
                .setRouteParam("id", id);
        } else {
            this.setRoute("/api/v1/brand/{bid}/intramirror-map")
                .setRouteParam("bid", brandId);
        }
        
        if(token !== undefined && token !== null) {
            this.appendAuthSchema(new JWTAuth(token))
        }
    }

}